import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import "assets/css/App.css";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import AuthLayout from "layouts/auth";
import AdminLayout from "layouts/admin";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "theme/theme";
import { ThemeEditorProvider } from "@hypertheme-editor/chakra-ui";
import ProtectedRoute from "./authentication";
import TermsAndConditions from "pages/TermsAndConditions";

axios.defaults.withCredentials = true;

axios.interceptors.response.use(
  function (response) {
    const newAccessToken = response.headers["authorization"];

    if (newAccessToken) {
      const token = newAccessToken.split(" ")[1];

      localStorage.setItem("token", token);
    }

    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <ChakraProvider theme={theme}>
    <React.StrictMode>
      <ThemeEditorProvider>
        <BrowserRouter>
          <Switch>
            <Route path={`/auth`} component={AuthLayout} />
            <ProtectedRoute path={`/admin`} component={AdminLayout} />
            <Route path={`/terms`} component={TermsAndConditions} />
            <Redirect from="/" to="/auth" />
          </Switch>
        </BrowserRouter>
      </ThemeEditorProvider>
    </React.StrictMode>
  </ChakraProvider>,
  document.getElementById("root")
);
